import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="hero text-white">
      <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center">
        <div>
          <div className="badge-soft mb-2">404</div>
          <h1 className="display-6 fw-bold">This page doesn’t exist.</h1>
          <p className="lead mb-0">The route you followed isn’t part of the PulseFrame demo.</p>
        </div>
        <Link className="cta-btn primary" to="/">
          Back home
        </Link>
      </div>
    </section>
  );
}

